import { render, staticRenderFns } from "./StationInfo.vue?vue&type=template&id=1c663a22&scoped=true&"
import script from "./StationInfo.vue?vue&type=script&lang=js&"
export * from "./StationInfo.vue?vue&type=script&lang=js&"
import style0 from "./StationInfo.vue?vue&type=style&index=0&id=1c663a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c663a22",
  null
  
)

export default component.exports